var map = {
	"./favicon/logo": 41,
	"./favicon/logo.png": 41,
	"./favicon/safari-pinned-tab": 42,
	"./favicon/safari-pinned-tab.svg": 42,
	"./placeholder/placeholder-16x9": 43,
	"./placeholder/placeholder-16x9.jpg": 43,
	"./placeholder/placeholder-1x1": 44,
	"./placeholder/placeholder-1x1.jpg": 44,
	"./placeholder/placeholder-1x1_5": 45,
	"./placeholder/placeholder-1x1_5.jpg": 45,
	"./placeholder/placeholder-2x1": 46,
	"./placeholder/placeholder-2x1.jpg": 46,
	"./placeholder/placeholder-32x9": 47,
	"./placeholder/placeholder-32x9.jpg": 47,
	"./placeholder/placeholder-3x2": 48,
	"./placeholder/placeholder-3x2.jpg": 48,
	"./placeholder/placeholder-3x4": 49,
	"./placeholder/placeholder-3x4.jpg": 49,
	"./placeholder/placeholder-8x9": 50,
	"./placeholder/placeholder-8x9.jpg": 50,
	"./schema/logo": 51,
	"./schema/logo.png": 51,
	"./social_sharing/facebook": 52,
	"./social_sharing/facebook.png": 52,
	"./social_sharing/twitter": 53,
	"./social_sharing/twitter.png": 53,
	"./template/CPA-email-footer": 54,
	"./template/CPA-email-footer.png": 54,
	"./template/CPA-email-header": 55,
	"./template/CPA-email-header.png": 55,
	"./template/arrow-down": 16,
	"./template/arrow-down.png": 16,
	"./template/arrow-down.svg": 132,
	"./template/arrow-left": 17,
	"./template/arrow-left.png": 17,
	"./template/arrow-left.svg": 133,
	"./template/arrow-right": 18,
	"./template/arrow-right.png": 18,
	"./template/arrow-right.svg": 134,
	"./template/arrow-up": 19,
	"./template/arrow-up.png": 19,
	"./template/arrow-up.svg": 135,
	"./template/basket": 56,
	"./template/basket.svg": 56,
	"./template/download": 20,
	"./template/download.png": 20,
	"./template/download.svg": 136,
	"./template/email": 57,
	"./template/email.svg": 57,
	"./template/icon--download": 58,
	"./template/icon--download-compact": 59,
	"./template/icon--download-compact.svg": 59,
	"./template/icon--download.svg": 58,
	"./template/icon--link-external": 60,
	"./template/icon--link-external.svg": 60,
	"./template/icon--map-marker_smaller": 61,
	"./template/icon--map-marker_smaller.svg": 61,
	"./template/logo": 62,
	"./template/logo.svg": 62,
	"./template/logos/gallagher": 63,
	"./template/logos/gallagher.png": 63,
	"./template/logos/jcb": 64,
	"./template/logos/jcb.png": 64,
	"./template/logos/lighthouse": 65,
	"./template/logos/lighthouse.png": 65,
	"./template/logos/mcs": 66,
	"./template/logos/mcs.png": 66,
	"./template/logos/ridgway": 67,
	"./template/logos/ridgway.png": 67,
	"./template/logos/tyrefix": 68,
	"./template/logos/tyrefix.png": 68,
	"./template/map-cluster-markers/m1": 69,
	"./template/map-cluster-markers/m1.png": 69,
	"./template/map-cluster-markers/m2": 70,
	"./template/map-cluster-markers/m2.png": 70,
	"./template/map-cluster-markers/m3": 71,
	"./template/map-cluster-markers/m3.png": 71,
	"./template/map-cluster-markers/m4": 72,
	"./template/map-cluster-markers/m4.png": 72,
	"./template/map-cluster-markers/m5": 73,
	"./template/map-cluster-markers/m5.png": 73,
	"./template/map-pin": 74,
	"./template/map-pin.png": 74,
	"./template/placeholder": 75,
	"./template/placeholder.png": 75,
	"./template/sagepay": 76,
	"./template/sagepay.png": 76,
	"./template/search": 77,
	"./template/search.svg": 77,
	"./template/select-arrow-down": 21,
	"./template/select-arrow-down.png": 21,
	"./template/select-arrow-down.svg": 137,
	"./template/spacer": 78,
	"./template/spacer.gif": 78,
	"./template/tick": 22,
	"./template/tick.png": 22,
	"./template/tick.svg": 138,
	"./template/touch-gesture": 79,
	"./template/touch-gesture.svg": 79,
	"./template/touch-gesture_01": 80,
	"./template/touch-gesture_01.svg": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;